export function sanitizeInput(value) {
    if (typeof value === 'string') {
        return value
            .replaceAll(/[\u0000-\u0009]/g, '')
            .replaceAll(/[\u000B-\u001F]/g, '')
            .replaceAll(/[\u0080-\u009F]/g, '');
    } else if (typeof value === 'number') {
        return value;
    } else {
        return '';
    }
}
